import {useContext} from "react";
import {ConfirmDialogProps, ConfirmDialogContext} from "../context/ConfirmDialogContext";

export function useConfirmDialog(): { showConfirmDialog: (data: ConfirmDialogProps) => Promise<boolean> } {
    const dialogHelpers = useContext(ConfirmDialogContext);
    return dialogHelpers;
}
